import { PayloadAction } from '@reduxjs/toolkit'
import { ICampaignState, ICampaign } from 'store/types/campaign'

const reducers = {
  setCampaign: (state: ICampaignState, action: PayloadAction<ICampaign>) => {
    state.campaign = action.payload
  }
}

export default reducers
